
import AdminLayout from "@/layouts/AdminLayout"
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { Link } from "react-router-dom"
import { Users, MessageSquare, History, FileText, ListPlus, Home, FolderOpen, MessageCircle, UserPlus } from "lucide-react"

export default function AdminDashboard() {
  const adminModules = [
    {
      title: "Welcome Dashboard",
      description: "View the main application dashboard",
      icon: Home,
      link: "/welcome?demo=true"
    },
    {
      title: "Client Directory",
      description: "View and manage all clients",
      icon: FolderOpen,
      link: "/client-directory"
    },
    {
      title: "Generated Content",
      description: "View all generated messages",
      icon: MessageCircle,
      link: "/generated-content"
    },
    {
      title: "Tier Prompts",
      description: "Manage AI prompts and summaries for each subscription tier",
      icon: MessageSquare,
      link: "/manage-prompts"
    },
    {
      title: "User Management",
      description: "View and manage user accounts",
      icon: Users,
      link: "/manage-users"
    },
    {
      title: "Beta Testers",
      description: "Create and manage beta tester accounts",
      icon: UserPlus,
      link: "/manage-beta-testers"
    },
    {
      title: "Field Management",
      description: "Configure client information fields and categories by tier",
      icon: ListPlus,
      link: "/manage-fields"
    },
    {
      title: "Client Categories",
      description: "Customize fields for client information",
      icon: FileText,
      link: "/manage-client-categories"
    },
    {
      title: "Prompt History",
      description: "View past prompts and summaries",
      icon: History,
      link: "/prompt-history"
    }
  ]

  return (
    <AdminLayout title="Admin Dashboard">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {adminModules.map((module) => (
          <Link key={module.title} to={module.link}>
            <Card className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <module.icon className="h-6 w-6 text-muted-foreground" />
                  <div>
                    <CardTitle className="text-lg">{module.title}</CardTitle>
                    <CardDescription>{module.description}</CardDescription>
                  </div>
                </div>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </AdminLayout>
  )
}
